import { useWindowSize } from "usehooks-ts";

export type BrowserSizeEnum  = "Desktop" | "Mobile" | "Tablet";

export function useBrowserInfo() : BrowserSizeEnum {
    const size = useWindowSize();

    if(size.width > 1024)
        return "Desktop";
    if(size.width > 768)
        return "Tablet";
    return "Mobile";
}